document.addEventListener("DOMContentLoaded", function () {
  const timers = document.querySelectorAll(".countdown-timer");

  timers.forEach((timerElement) => {
    let targetDate = timerElement.dataset.timer;

    if (!targetDate) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const day = String(tomorrow.getDate()).padStart(2, "0");
      const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const year = tomorrow.getFullYear();
      targetDate = `${day}/${month}/${year}`;
    }

    const [day, month, year] = targetDate.split("/");
    const formattedDate = `${year}-${month}-${day}`;

    function startTimer() {
      let countDownDate = new Date(formattedDate + "T00:00:00").getTime();

      function updateTimer() {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        if (distance < 0) {
          countDownDate = new Date().getTime() + 24 * 60 * 60 * 1000;
          return updateTimer();
        }

        const totalHours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        timerElement.innerHTML = `
          ${totalHours.toString().padStart(2, "0")}: 
          ${minutes.toString().padStart(2, "0")}: 
          ${seconds.toString().padStart(2, "0")}`;

        setTimeout(updateTimer, 1000);
      }

      updateTimer();
    }

    startTimer();
  });
});
